<template>
  <div
    class="shrink-0 overflow-hidden rounded-full bg-[#FFF0DA] ring-1 ring-black/10"
    :class="size === 'lg' ? 'h-14 w-14' : 'h-12 w-12'"
  >
    <img
      v-if="src && !imageError"
      :src="src"
      :alt="t('nav.topNav.accountManager')"
      class="h-full w-full object-cover object-[center_15%] scale-[1.12]"
      decoding="async"
      @error="imageError = true"
    />
    <div
      v-else
      class="flex h-full w-full items-center justify-center font-bold text-[#CBA461]"
      :class="size === 'lg' ? 'text-lg' : 'text-base'"
    >
      {{ initials }}
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    size?: 'md' | 'lg';
    src?: string | null;
    firstName?: string | null;
    lastName?: string | null;
  }>(),
  { size: 'md' },
);

const imageError = ref(false);

watch(
  () => props.src,
  () => {
    imageError.value = false;
  },
);

const initials = computed(() => {
  const value = `${props.firstName?.[0] || ''}${props.lastName?.[0] || ''}`.toUpperCase();
  return value || 'AM';
});
</script>
